module.exports = __webpack_public_path__ + "img/01.9091a9c5.jpg";